import { render, staticRenderFns } from "./CreateAlbum.vue?vue&type=template&id=c2b2f85e&scoped=true"
import script from "./CreateAlbum.vue?vue&type=script&lang=js"
export * from "./CreateAlbum.vue?vue&type=script&lang=js"
import style0 from "./CreateAlbum.vue?vue&type=style&index=0&id=c2b2f85e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b2f85e",
  null
  
)

export default component.exports